import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";

function isEmpty(val: unknown): boolean {
  return val === null || val === undefined || val === "";
}

function toNum(val: unknown): number {
  const n = Number(val);
  return isNaN(n) ? 0 : n;
}

export function useFeesCalculator(form: UseFormReturn<any>) {
  const [brokerFee, custodianBrokerFee, otherFee] = form.watch([
    "broker_fee",
    "custodian_broker_fee",
    "other_fee",
  ]);

  useEffect(() => {
    if (isEmpty(brokerFee) && isEmpty(custodianBrokerFee) && isEmpty(otherFee)) {
      const current = form.getValues("fees");
      if (!isEmpty(current)) {
        form.setValue("fees", null, { shouldDirty: true });
      }
      return;
    }
    const total = toNum(brokerFee) + toNum(custodianBrokerFee) + toNum(otherFee);
    const current = form.getValues("fees");
    if (isNaN(Number(current)) || total !== Number(current)) {
      form.setValue("fees", total, { shouldDirty: true });
    }
  }, [brokerFee, custodianBrokerFee, otherFee]);
}
